import { Button, Icon, Tooltip } from '@fattureincloud/fic-design-system'
import { faInfoCircle, faPlus, faSave } from '@fortawesome/pro-light-svg-icons'
import React, { FC, useState } from 'react'

import { locale } from '../../locales/locale'
import { EditButtonsContainer, SaveOrder } from '../common.components'
import AddSectionModal from '../DnDComponents/AddSectionModal'
import { SectionEditProps } from './definitions'
import { EditSectionHeader, SaveOrderContainer } from './sections.components'

const SectionEditButtons: FC<SectionEditProps> = (props: SectionEditProps) => {
  const [addingSection, setAddingSection] = useState<boolean>(false)

  return (
    <EditSectionHeader>
      {addingSection && (
        <AddSectionModal
          onClose={() => setAddingSection(false)}
          parentSectionId={props.parent_section}
          onSuccess={() => {
            props.reloadSection()
            setAddingSection(false)
          }}
        />
      )}
      <EditButtonsContainer>
        <Button
          text={props.parent_section ?
              locale('Aggiungi') + ' ' +  locale('Sottosezione')
              :
              locale('Aggiungi') + ' ' + locale('Sezione')}
          color={'blue'}
          iconLeft={{ icon: faPlus }}
          onClick={() => setAddingSection(true)}
        />
        <SaveOrderContainer>
          <SaveOrder
            text={locale('Salva ordinamento')}
            color={'green'}
            iconLeft={{ icon: faSave }}
            type={'secondary'}
            onClick={props.saveOrder}
          />
          <Tooltip
            message={
              locale('Ordina i vari titoli degli articoli o sezioni e poi premi ') +
              locale('Salva ordinamento') + locale(" per salvare l'ordine scelto.")
            }
            placement={'left'}
            type={'dark'}
          >
            <Icon icon={faInfoCircle} />
          </Tooltip>
        </SaveOrderContainer>
      </EditButtonsContainer>
    </EditSectionHeader>
  )
}

export default SectionEditButtons
